import { Link as RouterLink } from 'react-router-dom';
import { Button, CircularProgress, IconButton, IconButtonPropsColorOverrides, IconButtonPropsSizeOverrides, Tooltip } from '@mui/material';
import { ButtonTypeMap } from "@mui/material"
import { OverridableStringUnion } from '@mui/types';
import { ReactNode } from "react";

export interface ActionButtonProps {
  title?: string;
  actionUrl?: string;
  isSubmitting?: boolean;
  variant?: ButtonTypeMap["props"]["variant"];
  iconButton?: boolean;
  icon?: ReactNode;
  actionType?: string;
  target?: string;
  tooltipText?:string;
  className?:string;
  disabled?:boolean;
  values?: {};
  color?: OverridableStringUnion<
    'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
    IconButtonPropsColorOverrides
  >
  onClick?: Function;
  size?:  OverridableStringUnion<"small" | "medium" | "large", IconButtonPropsSizeOverrides>
}

export const CustomButton = ({
  title,
  actionUrl = null,
  isSubmitting = false,
  variant = 'contained',
  iconButton,
  tooltipText: tooltipText = "",
  icon,
  disabled = false,
  actionType,
  target = "_self",
  values,
  color = "primary",
  onClick: actionFunction = ()=> (console.log("Action Function not Implemented")),
  size = "medium",
  className = "custom-button-"+title?.replace(/ /g, "-").toLowerCase()
}: ActionButtonProps) => {
  const isDisabled = Boolean(isSubmitting ? true : disabled ?? isSubmitting);
  const hasTooltip = Boolean(tooltipText?.trim());

  if (iconButton) {
    if (actionUrl) {
      return (
        <Tooltip title={tooltipText} arrow disableHoverListener={!hasTooltip}>
          <span style={{ display: "inline-flex" }}>
            <IconButton
              aria-label={title ?? tooltipText}
              component={RouterLink}
              disabled={isDisabled}
              to={actionUrl ?? ''}
              onClick={(e) => { actionFunction(e) }}
              color={color}
              target={target}
              size={size}
              className={className}
            >
              {icon}
            </IconButton>
          </span>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={tooltipText} arrow disableHoverListener={!hasTooltip}>
          <span style={{ display: "inline-flex" }}>
            <IconButton
              aria-label={title ?? tooltipText}
              onClick={(e) => { actionFunction(e) }}
              color={color}
              disabled={isDisabled}
              size={size}
              className={className}
            >
              {icon}
            </IconButton>
          </span>
        </Tooltip>
      );
    }
  } else {
    if (actionUrl) {
      return (
        <Tooltip title={tooltipText} arrow disableHoverListener={!hasTooltip}>
          <span style={{ display: "inline-flex", width: "100%" }}>
            <Button
              component={RouterLink}
              to={actionUrl ?? ""}
              target={target}
              className={className}
              variant={variant}
              color={color as "inherit" | "primary" | "secondary" | "error" | "info" | "success" | "warning"}
              fullWidth
              startIcon={isSubmitting ? <CircularProgress size="1rem" /> : (icon)}
              disabled={isDisabled}
              size={size}
              sx={{ mt: { xs: 1, sm: 0 } }}
            >
              {title}
            </Button>
          </span>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={tooltipText} arrow disableHoverListener={!hasTooltip}>
          <span style={{ display: "inline-flex", width: "100%" }}>
            <Button
              onClick={(e) => { actionFunction(e) }}
              variant={variant}
              fullWidth
              className={className}
              size={size}
              color={color as "inherit" | "primary" | "secondary" | "error" | "info" | "success" | "warning"}
              startIcon={isSubmitting ? <CircularProgress size="1rem" /> : (icon)}
              disabled={isDisabled}
              sx={{ mt: { xs: 1, sm: 0 }, color:color }}
            >
              {title}
            </Button>
          </span>
        </Tooltip>
      );
    }
  }
}

export default CustomButton;
